import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckCircleSolidIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M16 28.8C8.93 28.8 3.2 23.07 3.2 16S8.93 3.2 16 3.2 28.8 8.93 28.8 16 23.07 28.8 16 28.8m5.9-18.315a1.2 1.2 0 0 0-1.676.265l-5.97 8.21-2.605-2.605a1.2 1.2 0 0 0-1.695 1.695l3.6 3.6c.25.25.59.375.94.35s.67-.205.875-.49l6.795-9.35a1.2 1.2 0 0 0-.265-1.675" })
});
export default SvgCheckCircleSolidIcon;
